import AHDate from "_shared/dates/date";
import Guid from "_shared/guids/guid";
import { Bookmark, BookmarkType } from "marketplace/bookmarks/bookmark";
import BookmarkedIndividualSchema, { BookmarkedIndividualJSON, BookmarkedIndividualParams } from "marketplace/bookmarks/individual-bookmarks/_schema/bookmarked-individual-schema";
import Entity from '_framework/entities/entity';

export default class BookmarkedIndividual extends Entity<BookmarkedIndividual, BookmarkedIndividualJSON, BookmarkedIndividualParams> implements Bookmark {
  public static get EXAMPLE(): BookmarkedIndividual {
    return new BookmarkedIndividual({
      id: Guid.generate(),
      createdDate: AHDate.TODAY,
      individualId: Guid.generate()
    });
  }

  public static create(values: BookmarkedIndividualParams): BookmarkedIndividual {
    const parsed = BookmarkedIndividualSchema.validate(values);
    return new BookmarkedIndividual(parsed);
  }

  public static fromJSON(json: BookmarkedIndividualJSON): BookmarkedIndividual {
    const parsed = BookmarkedIndividualSchema.deserialize(json);
    return new BookmarkedIndividual(parsed);
  }

  public static fromJSONArray(jsonArray: BookmarkedIndividualJSON[]): BookmarkedIndividual[] {
    return jsonArray.map((json) => BookmarkedIndividual.fromJSON(json));
  }


  public readonly id: Guid;
  public readonly createdDate: AHDate;
  public readonly individualId: Guid;

  public get type(): BookmarkType {
    return BookmarkType.Individual;
  }

  public constructor(params: BookmarkedIndividualParams) {
    super(params);
    this.id = params.id;
    this.createdDate = params.createdDate;
    this.individualId = params.individualId;
  }

  public toJSON(): BookmarkedIndividualJSON {
    return BookmarkedIndividualSchema.serialize(this);
  }

  public valueOf(): BookmarkedIndividualJSON {
    return this.toJSON();
  }

  public toString(): string {
    return `Bookmarked Individual: 
        Id: ${this.id.toString()}
        CreatedDate: ${this.createdDate.toString()}
        IndividualId: ${this.individualId.toString()}
      )`;
  }

  public isEqualTo(other: BookmarkedIndividual | null | undefined): boolean {
    return Boolean(other
      && this.id.isEqualTo(other.id)
      && this.createdDate.isEqualTo(other.createdDate)
      && this.individualId.isEqualTo(other.individualId)
    );
  }
}
